import { cvvSchema } from 'shared/components/vxl/input/schemas/card/cvv.schema';
import { debitCardNumberSchema } from 'shared/components/vxl/input/schemas/card/debitCardNumber.schema';
import { expirationDateSchema } from 'shared/components/vxl/input/schemas/card/expirationDate.schema';
import { emailSchema } from 'shared/components/vxl/input/schemas/email.schema';
import { usStateSchema } from 'shared/components/vxl/input/schemas/usState.schema';
import { zipCodeSchema } from 'shared/components/vxl/input/schemas/zipCode.schema';
import { NAME_REGEX } from 'shared/utils/string/name';
import { z } from 'zod';

export const MAX_CARD_EXPIRY_YEAR = 10;

export const nameValidationMessages = {
  required: 'Required',
  invalid_minimum_length: 'Minimum 2 characters',
  invalid_characters: 'You can only use letters, hyphens, and apostrophes.',
};

const v2aNameSchema = z
  .string({ error: nameValidationMessages.required })
  .min(1, { error: nameValidationMessages.required })
  .min(2, { error: nameValidationMessages.invalid_minimum_length })
  .regex(NAME_REGEX, {
    error: nameValidationMessages.invalid_characters,
  });

export const paymentDetailsFormSchema = z.object({
  firstName: v2aNameSchema,
  lastName: v2aNameSchema,
  email: emailSchema,
  cardNumber: debitCardNumberSchema,
  date: expirationDateSchema,
  cvv: cvvSchema,
  state: usStateSchema,
  zipCode: zipCodeSchema,
  isActiveTerms: z.boolean().refine((val) => val === true, {
    error: 'Required',
  }),
  isActiveMarketing: z.boolean(),
});
